import React, { lazy, Suspense, useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { OpenInNew } from '@mui/icons-material';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { db } from '../../utils/firebase';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Link } from 'react-router-dom';
import { handleCopy } from '../../utils/Universalfunctions';
const ImageMasonryPanel = lazy(() => import('./ImageMasonryPanel'));

const breakpoints = {
     default: 5,
     1400: 5,
     1000: 3,
     700: 2,
     500: 2,
};

const GeneratedImagesMasonry = ({ userData }) => {
     const [images, setImages] = useState([]);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState('');
     const [selectedImage, setSelectedImage] = useState(null);
     const [showCanvas, setShowCanvas] = useState(false);
     const [loadedImages, setLoadedImages] = useState({});
     const [subscriberVisibleCount, setSubscriberVisibleCount] = useState(30);



     useEffect(() => {
          setLoading(true);
          setError('');

          const q = query(
               collection(db, 'generations'),
               orderBy('time', 'desc')
          );

          const unsubscribe = onSnapshot(
               q,
               (snapshot) => {
                    const data = snapshot.docs.map((doc) => ({
                         id: doc.id,
                         ...doc.data(),
                    }));
                    // .filter((item) => item.visibility === 'public')

                    setImages(data);
                    setLoading(false);
               },
               (err) => {
                    console.error('Firestore realtime error:', err);
                    setError(err.message || 'Unable to load generated images.');
                    setLoading(false);
               }
          );

          return () => unsubscribe();
     }, []);

     const handleOpenCanvas = (item) => {
          setSelectedImage(item);
          setShowCanvas(true);
     };

     const handleCloseCanvas = () => {
          setShowCanvas(false);
          setSelectedImage(null);
     };

     const handleImageLoad = (id) => {
          setLoadedImages((prev) => ({
               ...prev,
               [id]: true,
          }));
     };

     const formatDate = (value) => {
          if (!value) return 'N/A';

          try {
               if (value?.seconds) {
                    return new Date(value.seconds * 1000).toLocaleString();
               }

               return new Date(value).toLocaleString();
          } catch (err) {
               return 'N/A';
          }
     };


     const publicImages = images.filter((item) => item.visibility === 'public');
     const subscriberImages = images.filter((item) => item.visibility === 'subscribers');
     const myImages = images.filter((item) => item.userID === userData?.uid);

     const ITEMS_PER_LOAD = 30;

     const [exploreVisibleCount, setExploreVisibleCount] = useState(30);
     const [myVisibleCount, setMyVisibleCount] = useState(30);

     const visiblePublicImages = publicImages.slice(0, exploreVisibleCount);
     const visibleSubscriberImages = subscriberImages.slice(0, exploreVisibleCount);
     const visibleMyImages = myImages.slice(0, myVisibleCount);
     const canViewSubscriberImages = userData?.isPremium === true && userData?.subscriptions === 'paid';

     if (loading) {
          return <div className="generated-gallery-state text-center">Loading images...</div>;
     }

     if (error) {
          return <div className="generated-gallery-state error text-center">{error}</div>;
     }

     if (!images.length) {
          return <div className="generated-gallery-state text-center">No images found.</div>;
     }

     return (
          <>
               <div className="generated-gallery-section">
                    <div className="__container-gallery-section">

                         <Tabs defaultIndex={1}>
                             <div className='__tabs-link-coners'>
                               <TabList>
                                   <Tab> <span>🜲</span> Subscribers Only</Tab>
                                   <Tab>Explore</Tab>
                                   <Tab> My stuff</Tab>
                                   <Link to="/submit" className="react-tabs__tab ">Submit Prompt</Link>
                                   <Link to="/category/google-gemini-prompts" className="react-tabs__tab ">Gemini </Link>
                                   <Link to="/category/chatgpt-prompts" className="react-tabs__tab ">Chatgpt</Link>
                                   <Link to="/category/chatgpt-prompts" className="react-tabs__tab ">Midjourney</Link>
                                   <Link to="/18+" className="react-tabs__tab bg-danger">Hot</Link>
                              </TabList>
                             </div>



                              <TabPanel>
                                   {!userData?.uid ? (
                                        <p className="text-center mt-5">
                                             Please log in to access subscriber-only images.
                                        </p>
                                   ) : !canViewSubscriberImages ? (
                                        <p className="text-center mt-5">
                                             This content is available only for active subscribers.
                                        </p>
                                   ) : (
                                        <Suspense fallback={<p className="text-center">Loading...</p>}>
                                             <ImageMasonryPanel
                                                  images={subscriberImages}
                                                  visibleImages={visibleSubscriberImages}
                                                  loadedImages={loadedImages}
                                                  handleImageLoad={handleImageLoad}
                                                  handleOpenCanvas={handleOpenCanvas}
                                                  visibleCount={subscriberVisibleCount}
                                                  totalCount={subscriberImages.length}
                                                  onShowMore={() =>
                                                       setSubscriberVisibleCount((prev) => prev + ITEMS_PER_LOAD)
                                                  }
                                                  emptyMessage="No subscriber images found."
                                                  breakpointCols={breakpoints}
                                             />
                                        </Suspense>
                                   )}
                              </TabPanel>

                              <TabPanel>
                                   <Suspense fallback={<p className="text-center">Loading...</p>}>
                                        <ImageMasonryPanel
                                             images={publicImages}
                                             visibleImages={visiblePublicImages}
                                             loadedImages={loadedImages}
                                             handleImageLoad={handleImageLoad}
                                             handleOpenCanvas={handleOpenCanvas}
                                             visibleCount={exploreVisibleCount}
                                             totalCount={publicImages.length}
                                             onShowMore={() => setExploreVisibleCount((prev) => prev + ITEMS_PER_LOAD)}
                                             emptyMessage="No public images found."
                                             breakpointCols={breakpoints}
                                        />
                                   </Suspense>
                              </TabPanel>


                              <TabPanel>
                                   {!userData?.uid ? (
                                        <p className="text-center mt-5">
                                             Please log in to view your generated images.
                                        </p>
                                   ) : (
                                        <Suspense fallback={<p className="text-center">Loading...</p>}>
                                             <ImageMasonryPanel
                                                  images={myImages}
                                                  visibleImages={visibleMyImages}
                                                  loadedImages={loadedImages}
                                                  handleImageLoad={handleImageLoad}
                                                  handleOpenCanvas={handleOpenCanvas}
                                                  visibleCount={myVisibleCount}
                                                  totalCount={myImages.length}
                                                  onShowMore={() => setMyVisibleCount((prev) => prev + ITEMS_PER_LOAD)}
                                                  emptyMessage="No images found in your account."
                                                  breakpointCols={breakpoints}
                                                  showVisibilityBadge={true}
                                             />
                                        </Suspense>
                                   )}
                              </TabPanel>

                         </Tabs>

                    </div>
               </div>

               <Offcanvas
                    show={showCanvas}
                    onHide={handleCloseCanvas}
                    placement="end"
                    className="offcanvas-generate-img"
               >
                    <Offcanvas.Header closeButton>
                         <div className="canvas-head">
                              <span className="canvas-mini-label">Image Details</span>
                              {/* <Offcanvas.Title>Generated Image Preview</Offcanvas.Title> */}
                         </div>
                    </Offcanvas.Header>

                    <Offcanvas.Body>
                         {selectedImage ? (
                              <div className="canvas-details-wrap">
                                   <div className="canvas-preview-card">
                                        <div className="canvas-preview">
                                             <img
                                                  src={selectedImage.imageurl}
                                                  alt={selectedImage.prompt || 'Generated output'}
                                             />
                                        </div>

                                        <div className="canvas-overlay-actions">
                                             <a
                                                  href={selectedImage.imageurl.replace(
                                                       '/upload/',
                                                       '/upload/fl_attachment/'
                                                  )}
                                                  className="download-btn"
                                             >
                                                  Download
                                             </a>

                                             <a
                                                  href={selectedImage.imageurl}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="open-btn"
                                             >
                                                  <OpenInNew />
                                                  <span>Open</span>
                                             </a>
                                        </div>
                                   </div>

                                   <div className="canvas-top-meta">
                                        <div className="top-meta-card">
                                             <span>Visibility</span>
                                             <strong>{selectedImage.visibility || 'public'}</strong>
                                        </div>

                                        <div className="top-meta-card">
                                             <span>Status</span>
                                             <strong>{selectedImage.status || 'success'}</strong>
                                        </div>

                                        <div className="top-meta-card">
                                             <span>Model</span>
                                             <strong>
                                                  {selectedImage.modal || selectedImage.model || 'N/A'}
                                             </strong>
                                        </div>

                                        <div className="top-meta-card">
                                             <span>Cost</span>
                                             <strong>{selectedImage.generatecost || '-50'}</strong>
                                        </div>
                                   </div>

                                   <div
                                        className={`canvas-prompt-card ${selectedImage.visibility}-card`}
                                   >
                                        <div className="prompt-head">
                                             <span>Prompt</span>

                                             <button
                                                  className="copy-btn"
                                                  onClick={() => handleCopy(selectedImage.prompt)}
                                             >
                                                  Copy
                                             </button>
                                        </div>

                                        <strong>
                                             {selectedImage.prompt || 'N/A'}
                                        </strong>
                                   </div>

                                   <div className="canvas-info-grid">
                                        {/* <div className="info-card">
                                             <span>Username</span>
                                             <strong>{selectedImage.username || 'Unknown User'}</strong>
                                        </div> */}

                                        <div className="info-card">
                                             <span>Seed</span>
                                             <strong>{selectedImage.seed || 'N/A'}</strong>
                                        </div>

                                        <div className="info-card">
                                             <span>Size</span>
                                             <strong>
                                                  {selectedImage.width || 'N/A'} ×{' '}
                                                  {selectedImage.height || 'N/A'}
                                             </strong>
                                        </div>

                                        <div className="info-card">
                                             <span>Generated Time</span>
                                             <strong>{formatDate(selectedImage.time)}</strong>
                                        </div>
                                   </div>
                              </div>
                         ) : null}
                    </Offcanvas.Body>
               </Offcanvas>
          </>
     );
};

export default GeneratedImagesMasonry;